import React, { useEffect, useState } from 'react';
import { Table, Form, Row, Col, Select, Input, DatePicker, Divider, Button, Typography, InputNumber } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { States, State, Institucion } from 'sigt';
import { connect } from 'react-redux';
import { FormInstance } from 'antd/lib/form';
import moment from 'moment';
import { Utils } from '../../../utils/validators';
import { bankCodes } from '../../../utils/banks';

const MultipleTransactions: React.FC<MultipleTransactionsProps> = ({
  banks,
  auth,
  selectedInstitution,
  form,
  data,
  maxCred = 0,
  selectedReqType,
  maxCredR = 0,
  disableMultipleTransaction = false,
}) => {
  // BOD, BANESCO Y BNC
  const sedematBanks = [11, 65, 39, 38, 43, 67, 74, 58, 63, 68, 2];
  const ecodebaBanks = [2, 11];
  const destinationBank = selectedInstitution?.id === 10 ? ecodebaBanks : sedematBanks;
  const [selectedCode, setSelectedCode] = useState<string>('');
  const creditoBloqueado = [22,25,40];

  useEffect(() => {
    if (data.pagos && data.pagos.length > 0) {
      console.log(data)
      console.log(data.pagos[0])
      if (['PAGOMOVILBNC','VPOSBNC'].includes(data.pagos[0]?.metodoPago)) {
        console.log('set monto')
        if (auth?.user?.tipoUsuario === 4) {
          form.setFieldsValue({
            pagos: data.pagos.map((p) => ({ ...p, 
              costo: data.monto || p.costo || 0, 
              codigo: selectedCode, 
              titular: auth?.user?.nombreCompleto,
              documento: auth?.user?.cedula,
              tipoDocumento: auth?.user?.nacionalidad,
            })),
          })          
        } else {
          form.setFieldsValue({
            pagos: data.pagos.map((p) => ({ ...p, 
              costo: data.monto || p.costo || 0, 
              codigo: selectedCode,
            })),
          }) 
        }
      }
    }
  },[data, selectedCode])

  const bankColumns: ColumnsType<any> = [
    {
      title: 'Banco',
      dataIndex: 'banco',
      key: 'banco',
      fixed: 'left',
    },
    {
      title: 'Numero de Cuenta',
      dataIndex: 'numeroCuenta',
      key: 'numeroCuenta',
    },
    {
      title: 'Titular',
      dataIndex: 'nombreTitular',
      key: 'nombreTitular',
    },
    {
      title: 'Documento de Identidad',
      dataIndex: 'documento',
      key: 'documento',
    },
    {
      title: 'Telefono',
      dataIndex: 'telefono',
      key: 'telefono',
    },
  ];

  const firstListItem = (fields, add) => {
    if (fields.length === 0) {
      // setTimeout(() => add(), 50);
      add();
    }
  };

  const alreadyUsedCredit = () => data.pagos && data.pagos.find((p) => p && p.metodoPago === 'CREDITO_FISCAL');
  const alreadyUsedCreditR = () => data.pagos && data.pagos.find((p) => p && p.metodoPago === 'CREDITO_FISCAL_RETENCION');

  const docTypeSelect = (field) => ( 
    <Form.Item noStyle name={[field.name, 'tipoDocumento']} rules={[{ required: true, message: 'Debe ingresar el tipo de documento del contribuyente' }]} >
      <Select>
        <Select.Option value='J'>J</Select.Option>
        <Select.Option value='G'>G</Select.Option>
        <Select.Option value='V'>V</Select.Option>
        <Select.Option value='E'>E</Select.Option>
        <Select.Option value='P'>P</Select.Option>
      </Select>
    </Form.Item>
  );

  const prefixSelect = (field) => (
    <Form.Item noStyle name={[field.name, 'prefijo']} >
      <Select>
        <Select.Option value='0424'>0424</Select.Option>
        <Select.Option value='0414'>0414</Select.Option>
        <Select.Option value='0412'>0412</Select.Option>
        <Select.Option value='0426'>0426</Select.Option>
        <Select.Option value='0416'>0416</Select.Option>
      </Select>
    </Form.Item>
  );

  return (
    <React.Fragment>
      <Table
        bordered
        pagination={false}
        style={{ marginBottom: 15 }}
        columns={bankColumns}
        dataSource={selectedInstitution?.cuentasBancarias?.map((c) => ({
          ...c,
          documento: `${c.rif ? 'RIF: ' : 'Cedula: '}${c.rif || c.cedula}`,
          banco: banks?.find((b) => b.id === c.banco)?.nombre,
          key: c.id,
        }))}
      />
      <Form.List name='pagos'>
        {(fields, { add, remove }) => (
          <div>
            {firstListItem(fields, add)}
            {fields.map((field, index) => (
              <React.Fragment key={field.key}>
                <Divider style={{ margin: 5, marginLeft: -5 }} orientation='left'>
                  <Typography.Text strong style={{ marginLeft: 5 }}>
                    Transacción {index + 1}
                  </Typography.Text>
                </Divider>
                <Form.Item required key={field.key} style={{ width: '100%', margin: 0 }}>
                  <Row gutter={24} style={{ padding: '0 20px' }}>
                    <Col xl={8} xs={24}>
                      <Form.Item
                        label='Método de Pago'
                        name={[field.name, 'metodoPago']}
                        rules={[{ required: true, message: 'Debe indicar el método de pago' }]}
                      >
                        <Select placeholder='Método de Pago' onChange={(v) => {
                          if(['PAGOMOVILBNC','VPOSBNC'].includes(String(v))) {
                          let pagos = data.pagos
                          pagos[field.key] = { ...pagos[field.key], costo: data.monto || 0, metodoPago: v };
                          form.setFieldsValue({pagos: pagos});
                          }
                        }}>
                          <Select.Option value='TRANSFERENCIA'>Transferencia</Select.Option>
                          <Select.Option value='PUNTO DE VENTA'>Punto de Venta</Select.Option>
                          {/* <Select.Option value='EFECTIVO'>Efectivo</Select.Option> */}
                          <Select.Option value='DEPOSITO'>Deposito</Select.Option>
                          {selectedReqType !== 'RETENCION' && maxCred && maxCred > 0 && !creditoBloqueado.includes(auth?.user?.cuentaFuncionario?.id_cargo || 0) && (
                            <Select.Option disabled={alreadyUsedCredit()} value='CREDITO_FISCAL'>
                              Credito Fiscal por compesanción
                            </Select.Option>
                          )}
                          {selectedReqType !== 'RETENCION' && maxCredR && maxCredR > 0 && !creditoBloqueado.includes(auth?.user?.cuentaFuncionario?.id_cargo || 0) && (
                            <Select.Option disabled={alreadyUsedCreditR()} value='CREDITO_FISCAL_RETENCION'>
                              Credito Fiscal por retención
                            </Select.Option>
                          )}
                          <Select.Option value='PAGOMOVILBNC'>Reportar Pago Móvil o Transferencia BNC</Select.Option>
                          {auth?.user?.tipoUsuario === 4  && <Select.Option value='VPOSBNC'>Punto Virtual BNC</Select.Option>}
                        </Select>
                      </Form.Item>
                    </Col>
                    {data.pagos &&
                      data.pagos[field.name]?.metodoPago !== 'EFECTIVO' &&
                      data.pagos[field.name]?.metodoPago !== 'CREDITO_FISCAL' &&
                      data.pagos[field.name]?.metodoPago !== 'CREDITO_FISCAL_RETENCION' && (
                        <Col xs={24} xl={8}>
                          <Form.Item
                            label='Banco de Origen'
                            name={[field.name, 'banco']}
                            fieldKey={field.fieldKey}
                            rules={[{ required: true, message: 'Debe indicar el banco' }]}
                          >
                            {banks ? (
                              <Select placeholder='Banco de Origen' onChange={(v) => {
                                  setSelectedCode(banks.find((b) => b.id === v)?.codigo_banco || '');
                                }}>
                                {data.pagos[field.name]?.metodoPago === 'PUNTO DE VENTA'
                                  ? banks?.map((b, i) => (
                                      <Select.Option key={`b-${b.id}`} value={b.id}>
                                        {b.nombre}
                                      </Select.Option>
                                    ))
                                  : banks
                                      ?.filter((b) => b.id !== 75)
                                      .map((b, i) => (
                                        <Select.Option key={`b-${b.id}`} value={b.id}>
                                          {b.nombre}
                                        </Select.Option>
                                      ))}
                              </Select>
                            ) : (
                              <div></div>
                            )}
                          </Form.Item>
                        </Col>
                      )}
                    {data.pagos &&
                      !['PAGOMOVILBNC','VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) &&
                      data.pagos[field.name]?.metodoPago !== 'EFECTIVO' &&
                      data.pagos[field.name]?.metodoPago !== 'CREDITO_FISCAL' &&
                      data.pagos[field.name]?.metodoPago !== 'CREDITO_FISCAL_RETENCION' && (
                        <Col xs={24} xl={8}>
                          <Form.Item
                            label='Banco de Destino'
                            name={[field.name, 'destino']}
                            fieldKey={field.fieldKey}
                            rules={[{ required: true, message: 'Debe indicar el banco' }]}
                          >
                            {banks ? (
                              <Select placeholder='Banco de Destino'>
                                {data.pagos[field.name]?.metodoPago === 'PUNTO DE VENTA'
                                  ? banks?.map((b, i) => (
                                      <Select.Option key={`b-${b.id}`} value={b.id}>
                                        {b.nombre}
                                      </Select.Option>
                                    ))
                                  : banks
                                      ?.filter((b) => selectedInstitution?.cuentasBancarias?.map((c) => c.banco).includes(b.id))
                                      .map((b, i) => (
                                        <Select.Option key={`b-${b.id}`} value={b.id}>
                                          {b.nombre}
                                        </Select.Option>
                                      ))}
                              </Select>
                            ) : (
                              <div></div>
                            )}
                          </Form.Item>
                        </Col>
                      )}
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Tipo de Cuenta' rules={[{ required: true, message: 'Por favor seleccione el tipo de cuenta' }]} name={[field.name, 'tipoCuenta']}>
                        <Select placeholder="Tipo de Cuenta">
                          <Select.Option value='00'>Principal</Select.Option>
                          <Select.Option value='10'>Ahorro</Select.Option>
                          <Select.Option value='20'>Corriente</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>}
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Documento' rules={[{ required: true, message: 'Por favor ingresar el documento del titular'}]} name={[field.name, 'documento']}>
                        <Input addonBefore={docTypeSelect(field)} placeholder="Documento" maxLength={9} disabled={auth?.user?.tipoUsuario === 4 ? true : false} />
                      </Form.Item>
                    </Col>}
                    {/* {data.pagos && ['PAGOMOVILBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Nro de Cuenta' rules={[{ required: true, message: 'Por favor ingrese el número de cuenta' }]} name={[field.name, 'cuenta']}>
                        <Input placeholder="Titular" maxLength={50}/>
                      </Form.Item>
                    </Col>}            */}
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Nombre del Titular' rules={[{ required: true, message: 'Por favor ingrese el nombre del titular' }]} name={[field.name, 'titular']}>
                        <Input placeholder="Titular" maxLength={50} disabled={auth?.user?.tipoUsuario === 4 ? true : false} />
                      </Form.Item>
                    </Col>} 
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Número de Tarjeta' rules={[{ required: true, message: 'Por favor ingrese el número de tarjeta' }]} name={[field.name, 'tarjeta']}>
                        <Input placeholder="Tarjeta" maxLength={20} minLength={20}/>
                      </Form.Item>
                    </Col>}   
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Pin de Tarjeta' rules={[{ required: true, message: 'Por favor ingrese el pin de la tarjeta' }]} name={[field.name, 'pin']}>
                        <Input placeholder="Pin" maxLength={6} minLength={4}/>
                      </Form.Item>
                    </Col>}
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='CVV de Tarjeta' rules={[{ required: true, message: 'Por favor ingrese el CVV de la tarjeta' }]} name={[field.name, 'cvv']}>
                        <Input placeholder="CVV" maxLength={3} minLength={3}/>
                      </Form.Item>
                    </Col>}
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Mes Exp. de Tarjeta' rules={[{ required: true, message: 'Por favor seleccione el mes de expiración de la tarjeta' }]} name={[field.name, 'mesEx']}>
                        <Select placeholder="Mes">
                          {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                            <Select.Option key={m} value={m}>{m < 10 ? `0${m}` : `${m}`}</Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>} 
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Año Exp. de Tarjeta' rules={[{ required: true, message: 'Por favor ingrese el año de expiración de la tarjeta' }]} name={[field.name, 'anioEx']}>
                        <Input placeholder="Año" maxLength={4} minLength={4}/>
                      </Form.Item>
                    </Col>}
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Tipo de Tarjeta' rules={[{ required: true, message: 'Por favor seleccione el tipo de tarjeta' }]} name={[field.name, 'tipoTarjeta']}>
                        <Select placeholder="Tipo de Tarjeta">
                          {/* <Select.Option value='1'>VISA</Select.Option> */}
                          {/* <Select.Option  value='2'>MasterCard</Select.Option> */}
                          <Select.Option value='3'>Débito Maestro</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>}           
                    {data.pagos && ['PAGOMOVILBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Teléfono' rules={[{ required: true, message: 'Por favor ingrese el teléfono del titular' }]} name={[field.name, 'telefono']}>
                        <Input addonBefore={prefixSelect(field)} placeholder="Teléfono" maxLength={7} minLength={7}/>
                      </Form.Item>
                    </Col>}

                    {data.pagos &&
                      !['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) &&
                      data.pagos[field.name]?.metodoPago !== 'EFECTIVO' &&
                      data.pagos[field.name]?.metodoPago !== 'CREDITO_FISCAL' &&
                      data.pagos[field.name]?.metodoPago !== 'CREDITO_FISCAL_RETENCION' && (
                        <Col xs={24} xl={8}>
                          <Form.Item
                            label='Numero de Referencia'
                            name={[field.name, 'referencia']}
                            fieldKey={field.fieldKey}
                            rules={[
                              { required: true, message: 'Por favor ingrese el numero de referencia.' },
                              { validator: Utils.validators.alphaNumericAndCharacters },
                            ]}
                          >
                            <Input placeholder='Referencia' />
                          </Form.Item>
                        </Col>
                      )}
                    { data.pagos && !['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) &&
                    <Col xs={24} xl={8}>
                      <Form.Item
                        label='Fecha de Pago'
                        name={[field.name, 'fecha']}
                        fieldKey={field.fieldKey}
                        rules={[{ required: true, message: 'Por favor ingrese la fecha de pago.' }]}
                      >
                        <DatePicker
                          style={{ width: '100%' }}
                          format={'DD-MM-YYYY'}
                          disabledDate={(current) => current > moment().endOf('day')}
                        />
                      </Form.Item>
                    </Col>}
                    <Col xs={24} xl={8}>
                      <Form.Item
                        label='Monto'
                        name={[field.name, 'costo']}
                        fieldKey={field.fieldKey}
                        rules={[{ required: true, message: 'Por favor ingrese el monto del pago.' }]}
                      >
                        <InputNumber
                          max={
                            data.pagos && data.pagos[field.name]?.metodoPago === 'CREDITO_FISCAL'
                              ? +(+maxCred || 0).toFixed(2)
                              : data.pagos && data.pagos[field.name]?.metodoPago === 'CREDITO_FISCAL_RETENCION'
                              ? +(+maxCredR || 0).toFixed(2)
                              : 999999999
                          }
                          value={data.pagos[field.name]?.costo}
                          formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                          parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                          min={0}
                          step={1}
                          style={{ width: '100%' }}
                          placeholder='Monto'
                        />
                      </Form.Item>
                    </Col>
                    {data.pagos && ['PAGOMOVILBNC','VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='' name={[field.name, 'codigo']} rules={[{ required: true }]}>
                        <Input hidden value={selectedCode}/>
                      </Form.Item>
                    </Col>}
                  </Row>
                </Form.Item>
              </React.Fragment>
            ))}
            {(( data.pagos && !['PAGOMOVILBNC','VPOSBNC'].includes(data?.pagos[0]?.metodoPago)) || !disableMultipleTransaction) && (
              <Row gutter={[16, 16]} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {fields.length > 1 && (
                  <Col>
                    <Button type='danger' onClick={() => remove(fields.length - 1)}>
                      Eliminar Transacción
                    </Button>
                  </Col>
                )}
                <Col>
                  <Button type='dashed' onClick={() => add()}>
                    Agregar Transacción
                  </Button>
                </Col>
              </Row>
            )}
          </div>
        )}
      </Form.List>
    </React.Fragment>
  );
};

const mapStateToProps = (state: State) => ({ banks: state.bk.banks, auth: state.auth });

export default connect(mapStateToProps)(MultipleTransactions);

interface MultipleTransactionsProps {
  banks: States.Banks['banks'];
  auth: States.Auth;
  selectedInstitution?: Institucion;
  form: FormInstance;
  data: any;
  maxCred?: number;
  maxCredR?: number;
  selectedReqType?: string;
  disableMultipleTransaction?: boolean;
}
